import { Box, Chip, IconButton, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material"
import SkeletonImage from "../../../../components/common/SkeletonImage"
import DocViewer from "../../../../components/common/DocViewer"
import { FILE_PATH_URI, handleDownload } from "../../../../utils/helper"
import Icons from "../../../../assets/js/Icons"
import { Fragment } from "react"
import moment from "moment"

import {
  additionalCertificatesLabel, specializationCertificateLabel,
  trainingBackgroundLabel, experienceLabel, specializationAreaLabel,
} from "./data"

function Professional({ specialist }) {
  const specializationId = specialist?.expertise?.specialization?._id

  return (
    <Fragment>
      <Typography sx={{ fontSize: "24px", fontWeight: "600" }}>Professional profile</Typography>
      <TableContainer className="adminTable2">
        <Table stickyHeader>
          <TableBody>
            <TableRow>
              <TableCell component="th">Profile photo</TableCell>
              <TableCell>
                <Box
                  sx={{
                    width: "250px",
                    borderRadius: 2,
                    overflow: "hidden",
                    aspectRatio: "1/1",
                    position: "relative",
                    display: "inline-block",
                  }}
                >
                  {specialist?.background?.profilePhoto &&
                    <IconButton
                      sx={{
                        top: "10px",
                        right: "10px",
                        border: "1px solid",
                        position: "absolute",
                        color: "primary.main",
                        bgcolor: "white !important",
                        borderColor: "primary.main"
                      }}
                      size="small"
                      onClick={() => { handleDownload(FILE_PATH_URI + specialist?.profile?.profilePhoto) }}
                    ><Icons.CloudDownloadSolid />
                    </IconButton>
                  }
                  <SkeletonImage src={FILE_PATH_URI + specialist?.profile?.profilePhoto} />
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th">Professional Bio</TableCell>
              <TableCell sx={{ whiteSpace: "normal !important" }}>
                {specialist?.profile?.professionalBio}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th">Service Description</TableCell>
              <TableCell sx={{ whiteSpace: "normal !important" }}>
                {specialist?.profile?.description}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th">Currency</TableCell>
              <TableCell>{specialist?.profile?.currency}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th">Service Rates</TableCell>
              <TableCell>{specialist?.profile?.price}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th">Time Zone</TableCell>
              <TableCell>{specialist?.profile?.timeZone}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th">Language spoken</TableCell>
              <TableCell>{specialist?.profile?.language}</TableCell>
            </TableRow>

            {/* Conditinal fields */}

            {specialist?.profile?.specializationCertificate?.length > 0 &&
              <TableRow>
                <TableCell component="th">{specializationCertificateLabel?.[specializationId] || "Certificate"}</TableCell>
                <TableCell>
                  <Box
                    sx={{
                      width: "250px",
                      borderRadius: 2,
                      overflow: "hidden",
                      aspectRatio: "1/1",
                      position: "relative",
                      display: "inline-block",
                    }}
                  >
                    {specialist?.background?.specializationCertificate?.[0]?.path &&
                      <IconButton
                        sx={{
                          top: "10px",
                          right: "10px",
                          border: "1px solid",
                          position: "absolute",
                          color: "primary.main",
                          bgcolor: "white !important",
                          borderColor: "primary.main"
                        }}
                        size="small"
                        onClick={() => { handleDownload(FILE_PATH_URI + specialist?.profile?.specializationCertificate?.[0]?.path) }}
                      ><Icons.CloudDownloadSolid />
                      </IconButton>
                    }
                    <SkeletonImage src={FILE_PATH_URI + specialist?.profile?.specializationCertificate?.[0]?.path} />
                  </Box>
                </TableCell>
              </TableRow>
            }

            {specialist?.profile?.additionalCertificates?.length > 0 &&
              <TableRow>
                <TableCell component="th">{additionalCertificatesLabel?.[specializationId] || "Additional Certificate"}</TableCell>
                <TableCell>
                  <Box
                    sx={{
                      width: "250px",
                      borderRadius: 2,
                      overflow: "hidden",
                      aspectRatio: "1/1",
                      position: "relative",
                      display: "inline-block",
                    }}
                  >
                    {specialist?.background?.additionalCertificates?.[0]?.path &&
                      <IconButton
                        sx={{
                          top: "10px",
                          right: "10px",
                          border: "1px solid",
                          position: "absolute",
                          color: "primary.main",
                          bgcolor: "white !important",
                          borderColor: "primary.main"
                        }}
                        size="small"
                        onClick={() => { handleDownload(FILE_PATH_URI + specialist?.profile?.additionalCertificates?.[0]?.path) }}
                      ><Icons.CloudDownloadSolid />
                      </IconButton>
                    }
                    <SkeletonImage src={FILE_PATH_URI + specialist?.profile?.additionalCertificates?.[0]?.path} />
                  </Box>
                </TableCell>
              </TableRow>
            }

            {specialist?.profile?.specializationareas?.length > 0 &&
              <TableRow>
                <TableCell component="th">{specializationAreaLabel?.[specializationId] || "Specialization Areas"}</TableCell>
                <TableCell sx={{ whiteSpace: "normal !important" }}>
                  {specialist?.profile?.specializationareas?.map(({ name }, i) => (
                    <Chip
                      label={name}
                      key={name + i}
                      variant="outlined"
                      sx={{
                        mb: 0.5,
                        borderRadius: 2,
                        fontFamily: "Poppins",
                        textTransform: "capitalize",
                      }}
                    />
                  ))
                  }
                </TableCell>
              </TableRow>
            }

            {specialist?.profile?.counselingApproach &&
              <TableRow>
                <TableCell component="th">Counseling Approach</TableCell>
                <TableCell>{specialist?.profile?.counselingApproach}</TableCell>
              </TableRow>
            }

            {specialist?.profile?.trainingBackground &&
              <TableRow>
                <TableCell component="th">{trainingBackgroundLabel?.[specializationId]}</TableCell>
                <TableCell>{specialist?.profile?.trainingBackground}</TableCell>
              </TableRow>
            }

            {specialist?.profile?.experience &&
              <TableRow>
                <TableCell component="th">{experienceLabel?.[specializationId] || "Profissional Experience"}</TableCell>
                <TableCell>{specialist?.profile?.experience || "value"}</TableCell>
              </TableRow>
            }

            {specialist?.profile?.spiritualPractices &&
              <TableRow>
                <TableCell component="th">Spiritual Practices</TableCell>
                <TableCell>{specialist?.profile?.spiritualPractices}</TableCell>
              </TableRow>
            }

            {specialist?.profile?.specializationAreaDescription &&
              <TableRow>
                <TableCell component="th">Specialization Area</TableCell>
                <TableCell>{specialist?.profile?.specializationAreaDescription}</TableCell>
              </TableRow>
            }

            {specialist?.profile?.clienteleFocus &&
              <TableRow>
                <TableCell component="th">Clientele Focus</TableCell>
                <TableCell>{specialist?.profile?.clienteleFocus}</TableCell>
              </TableRow>
            }

            {specialist?.profile?.qualificationDescription &&
              <TableRow>
                <TableCell component="th">Qualification</TableCell>
                <TableCell>{specialist?.profile?.qualificationDescription}</TableCell>
              </TableRow>
            }

            {specialist?.profile?.artTherapyTechniques &&
              <TableRow>
                <TableCell component="th">Art Therapy Techniques</TableCell>
                <TableCell>{specialist?.profile?.artTherapyTechniques}</TableCell>
              </TableRow>
            }

            {specialist?.profile?.ageGroupPreference &&
              <TableRow>
                <TableCell component="th">Age Group Preference</TableCell>
                <TableCell>{specialist?.profile?.ageGroupPreference}</TableCell>
              </TableRow>
            }

            {specialist?.profile?.targetClientele &&
              <TableRow>
                <TableCell component="th">Target Clientele</TableCell>
                <TableCell>{specialist?.profile?.targetClientele}</TableCell>
              </TableRow>
            }

            {specialist?.profile?.therapeuticMethods &&
              <TableRow>
                <TableCell component="th">Therapeutic Methods</TableCell>
                <TableCell>{specialist?.profile?.therapeuticMethods}</TableCell>
              </TableRow>
            }

            {specialist?.profile?.holisticPractices &&
              <TableRow>
                <TableCell component="th">Holistic Practices</TableCell>
                <TableCell>{specialist?.profile?.holisticPractices}</TableCell>
              </TableRow>
            }

            {specialist?.profile?.taiChiStyles &&
              <TableRow>
                <TableCell component="th">Tai Chi Styles</TableCell>
                <TableCell>{specialist?.profile?.taiChiStyles}</TableCell>
              </TableRow>
            }

            {specialist?.profile?.teachingExperience &&
              <TableRow>
                <TableCell component="th">Teaching Experience</TableCell>
                <TableCell>{specialist?.profile?.teachingExperience}</TableCell>
              </TableRow>
            }

            {specialist?.profile?.clientDemographics?.length > 0 &&
              <TableRow>
                <TableCell component="th">Clientele Demographics</TableCell>
                <TableCell>
                  <Box
                    sx={{
                      width: "250px",
                      borderRadius: 2,
                      overflow: "hidden",
                      aspectRatio: "1/1",
                      position: "relative",
                      display: "inline-block",
                    }}
                  >
                    {specialist?.background?.clientDemographics?.[0]?.path &&
                      <IconButton
                        sx={{
                          top: "10px",
                          right: "10px",
                          border: "1px solid",
                          position: "absolute",
                          color: "primary.main",
                          bgcolor: "white !important",
                          borderColor: "primary.main"
                        }}
                        size="small"
                        onClick={() => { handleDownload(FILE_PATH_URI + specialist?.profile?.clientDemographics?.[0]?.path) }}
                      ><Icons.CloudDownloadSolid />
                      </IconButton>
                    }
                    <SkeletonImage src={FILE_PATH_URI + specialist?.profile?.clientDemographics?.[0]?.path} />
                  </Box>
                </TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </TableContainer>

      <DocViewer />
    </Fragment>
  )
}

export default Professional